<template>
  <div class="document-content-records">
    <v-divider v-if="records.length"/>
    <div v-for="(record, index) in records" :key="index">
      <div class="document-content-record">
        <p style=" border-bottom: 1px dashed gray;padding-bottom: 16px;">
          <span class="accent--text">{{ record.nomenklatura_id}}</span> {{ record.name}}
        </p>
        <div style="text-align: right;">
          <v-layout align-center>
            <v-flex xs2>
              <input
                v-model.number="record.wanted"
                type="number"
                min="1"
                v-numericOnly
                pattern="\d*"
                class="table-qty">
            </v-flex>
            <v-flex xs10>
              {{ record.kolichestvo}} * <i>{{ record.tsena}} {{parseInt(record.has_nds_rate) ? '' : 'без НДС'}}</i> = <i>{{ record.kolichestvo * record.tsena |
              numberFormat(2, '.', ' ')}}</i>
              <v-btn
                color="white"
                icon
                @click="deleteRow(record)"
              >
                <v-icon color="red">
                  mdi-delete
                </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>

        </div>
      </div>
      <v-divider></v-divider>
    </div>
    <p class="text-xs-right document-content-record">
      Итого: <strong>{{ summa | numberFormat(2, '.', ' ') }}</strong>
    </p>
  </div>
</template>

<script>
import { numericOnly } from '@/directives/numericOnly'
import numberFormat from '@/filters/numberFormat'

export default {
  name: 'SchetList',
  directives: {
    numericOnly
  },
  filters: {
    numberFormat
  },
  props: {
    records: {
      default: () => [],
      required: true,
      type: Array
    },
    loading: {
      default: false,
      type: Boolean
    },
    summa: {
      default: 0,
      type: Number
    }
  },
  computed: {
    documentSumma () {
      let summa = 0
      this.records.forEach(function (v) {
        summa += parseFloat(v.tsena) * parseInt(v.kolichestvo)
      })

      return summa
    }
  },
  methods: {
    deleteRow (item) {
      this.$emit('deleteRow', item)
    }
  }
}
</script>

<style lang="stylus">
  .document-content-records {
  }

  .document-content-record {
    padding: 16px
  }

</style>
